import { Field } from "./field.model";
import { ContractAttachments } from 'src/app/core/class/contract-attachments';
import { EnterpriseEntity } from 'src/app/core/class/enterpriseEntity';
import { UserEntity } from 'src/app/core/class/UserEntity';
import { SignPosition } from "./sign-position.model";
export class DocumentDTO {
    id: string;
    code: string;
    codeAuto?: string;
    tempCode?:string;
    name: string;
    parentId: string;
    enterpriseId: string;
    documentTypeEnterpriseId: string;
    customerId: string;
    version: string;
    isSkipVersion: boolean;
    expiredDate: string;
    cancelTime: string;
    cancelReason: string;
    cancelUserFullName: string;
    rejectReason: string;
    fields: Array<Field>;
    templateFilePath: string;
    outputContentFile: any;
    fileSizeUpdate: string;
    fileNameUpdate: string;
    customerEnterpriseId: string;
    filePath: string;
    description: string;
    assignUserId: number;
    submitedTo: number;
    typeId: number;
    jsonData: string;
    email: string;
    phone: string;
    createdBy: string;
    finishDate: Date;
    documentTypeContent: string;
    contractAttachments: ContractAttachments[];
    newUploadContractAttachments: any[];
    serviceType: number;
    enterpriseSign: EnterpriseEntity[];
    userSign: UserEntity[];
    signPage: number;
    outputFilePath: string;
    tableModel: any;
    signPositions: SignPosition[];
    signatures: any;
    editedLotContract: boolean;
    mainContractAttachments: ContractAttachments[];
    signatureResponses: any;
    contractShares: any[];
  lstReferenceContractId?:any;
    negotiate?: boolean;
    contractSharePartners: any[];
    contractShareGroups: any[];
    dataDocumentParent: any[];
    formType: string;
    contractTerminationId: string;
    contractMohaFields?: any[];
    customerMohaId?: string;
    editProperty?: string;
    contractMohaUpdateFields?: any[];
    originalContractId?: string;
    messageAuthenDate: string;
    mohaSendTime: string;
    public static build(): DocumentDTO {
        const documentDTO: DocumentDTO = new DocumentDTO();

        documentDTO.id = null;
        documentDTO.code = null;
        documentDTO.codeAuto = null;
        documentDTO.name = null;
        documentDTO.parentId = null;
        documentDTO.enterpriseId = null;
        documentDTO.documentTypeEnterpriseId = null;
        documentDTO.customerId = null;
        documentDTO.version = null;
        documentDTO.isSkipVersion = null;
        documentDTO.expiredDate = null;
        documentDTO.cancelTime = null;
        documentDTO.cancelReason = null;
        documentDTO.cancelUserFullName = null;
        documentDTO.rejectReason = null;
        documentDTO.fields = null;
        documentDTO.templateFilePath = null;
        documentDTO.outputContentFile = null;
        documentDTO.fileNameUpdate = null;
        documentDTO.customerEnterpriseId = null;
        documentDTO.filePath = null;
        documentDTO.description = null;
        documentDTO.assignUserId = null;
        documentDTO.submitedTo = null;
        documentDTO.typeId = null;
        documentDTO.jsonData = null;
        documentDTO.email = null;
        documentDTO.phone = null;
        documentDTO.createdBy = null;
        documentDTO.finishDate = null;
        documentDTO.documentTypeContent = null;
        documentDTO.contractAttachments = null;
        documentDTO.newUploadContractAttachments = null;
        documentDTO.serviceType = null;
        documentDTO.enterpriseSign = null;
        documentDTO.userSign = null;
        documentDTO.signPage = null;
        documentDTO.signPositions = null;
        documentDTO.signatures = null;
        documentDTO.editedLotContract = null;
        documentDTO.mainContractAttachments = null;
        documentDTO.signatureResponses = null;
        documentDTO.contractShares = null;
        documentDTO.formType = null;
        documentDTO.contractTerminationId = null;
        documentDTO.contractMohaFields = null;
        documentDTO.customerMohaId = null;
        documentDTO.editProperty = null;
        documentDTO.contractMohaUpdateFields = null;
        documentDTO.originalContractId = null;
        documentDTO.messageAuthenDate = null;
        documentDTO.mohaSendTime = null;
        return documentDTO;
    }
}
